export function wrapN(n: number, min: number, max: number) {
  if (min === max) return min;
  if (isNaN(n)) throw new Error('wrapN: n must not be NaN');
  if (min > max) throw new Error('wrapN: min must be less than max');

  const maxLessMin = max - min;

  return ((((n - min) % maxLessMin) + maxLessMin) % maxLessMin) + min;
}
